import Showable from '~/Controller/Showable'

/**
 * Modal Aspect
 * Should only be used on <dialog> elements
 */
export default class Modal extends Showable {
	static props = {
		...Showable.props,
		selfClickHide: false,
		escHide: false,
		outClickHide: false,
		appendTo: '#modal-container',
		focusOnShow: true,
		pauseMediaOnHide: true,
		reloadIframeOnHide: true,
		autoShow: false,
	}
	
	// Store the shouldAutoShow value as a class property
	shouldAutoShow = false

	onShow(event) {
		// Only call showModal if the dialog is not already open to prevent InvalidStateError
		if (!this.element.open) {
			this.element.showModal()
		}
		
		super.onShow(event) // This will apply the --active class and aria-modal
		this.element.ariaModal = 'true'
	}
	onHide(event) {
		super.onHide(event)
		this.element.removeAttribute('aria-modal')
		if (event.detail.transition) {
			setTimeout(() => this.element.close(), this.duration)
		} else {
			this.element.close()
		}
	}

	initialized() {
		if (this.appendTo) {
			const container = document.querySelector(this.appendTo)
			if (container) {
				container.appendChild(this.element)
			}
		}
	}

	connected() {
		if (this.element.tagName !== 'DIALOG') throw new Error('Modal Aspect should only be used on dialog elements')
		super.connected()
		// hacky way to make dialog exit animation work
		// firefox doesn't support display animation yet, so we have to disable the native dialog close
		this.listeners.add(this.element, 'cancel', event => event.preventDefault())
		
		// Convert string value to boolean for autoShow
		const autoShowValue = this.element.dataset.autoShow
		this.shouldAutoShow = autoShowValue === 'true'
		
		// Auto-show modal if enabled (initial load)
		if (this.shouldAutoShow && !this.element.open) {
			window.requestAnimationFrame(() => {
				this.show({ trigger: 'autoShow' })
			})
		}
		
		// Check if this is a back navigation by seeing if the modal is already open
		// This happens when HTMX restores the page and the modal was previously open
		if (this.shouldAutoShow && this.element.open) {
			window.requestAnimationFrame(() => {
				
				this.element.classList.remove('--deactivating')
				
				
				this.element.classList.add('--active')
				
			
				this.element.close()
				this.element.showModal()
				
				this.element.ariaModal = 'true'
			})
		}
	}


	disconnected() {
		super.disconnected()
		this.listeners.clear()
	}
}
